// Servicio para integrar datos de PetFlix con el sistema de concursos
import { environment } from '../config/environment';

class PetflixIntegrationService {
  constructor() {
    this.baseUrl = environment.apiBaseUrl;
  }

  /**
   * Registra un usuario de PetFlix en concursos basándose en los classifiers del post
   * @param {Object} petflixPostData - Datos del post de PetFlix con classifiers y user
   * @returns {Promise<Object>} Resultado del registro
   */
  async registerUserFromClassifiers(petflixPostData) {
    try {
      const response = await fetch(`${this.baseUrl}/petflix/register-from-classifiers`, {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
        },
        body: JSON.stringify(petflixPostData)
      });

      if (!response.ok) {
        const errorData = await response.json().catch(() => ({}));
        throw new Error(errorData.error || `Error ${response.status}: ${response.statusText}`);
      }

      const data = await response.json();
      return {
        success: true,
        data: data
      };
    } catch (error) {
      console.error('Error registrando usuario desde classifiers:', error);
      return {
        success: false,
        error: error.message || 'Error desconocido al registrar usuario'
      };
    }
  }

  /**
   * Procesa múltiples posts de PetFlix y registra usuarios en concursos
   * @param {Array<Object>} posts - Array de posts de PetFlix
   * @returns {Promise<Object>} Resultado del procesamiento
   */
  async processMultiplePosts(posts) {
    const results = {
      total: posts.length,
      successful: 0,
      failed: 0,
      skipped: 0,
      details: []
    };

    for (const post of posts) {
      // Verificar que el post tenga classifiers y user
      if (!post.classifiers || !Array.isArray(post.classifiers) || post.classifiers.length === 0) {
        results.skipped++;
        results.details.push({
          postId: post._id,
          status: 'skipped',
          reason: 'No tiene classifiers'
        });
        continue;
      }

      if (!post.user) {
        results.skipped++;
        results.details.push({
          postId: post._id,
          status: 'skipped',
          reason: 'No tiene datos de usuario'
        });
        continue;
      }

      // Registrar usuario en concursos basándose en classifiers
      const result = await this.registerUserFromClassifiers(post);
      
      if (result.success) {
        results.successful++;
        results.details.push({
          postId: post._id,
          status: 'success',
          data: result.data
        });
      } else {
        results.failed++;
        results.details.push({
          postId: post._id,
          status: 'failed',
          error: result.error
        });
      }
    }

    return results;
  }
}

export default new PetflixIntegrationService();

